import { useHits } from 'react-instantsearch'
import { MlHorizontal } from '@curran-catalog/curran-atomic-library'
import React from 'react'
import { Hit } from 'instantsearch.js'

const getPreTitle = (item: Hit) => {
  switch (item?._tags) {
    case 'source:blogs':
      return 'Post'
    case 'source:contentful':
      return 'Page'
    case 'source:cloudinary':
      return 'PDF Document'
    default:
      return ''
  }
}

export interface TmPageResultHitsProps {
  hitsRef: React.RefObject<HTMLDivElement>
}

const getActionUrl = (item: Hit) => {
  if (item?.internalLink) {
    return item.internalLink.startsWith('/') ? item.internalLink : `/${item.internalLink}`
  }
  if (item?.externalLinks && Array.isArray(item?.externalLinks)) {
    return item.externalLinks[0]
  }
}
export const TmPageResultHits = ({ hitsRef }: TmPageResultHitsProps) => {
  const { hits } = useHits()

  return (
    <div ref={hitsRef} className="mb-14">
      {hits.map((item) => (
        <MlHorizontal
          key={item.objectID}
          preTitle={getPreTitle(item)}
          actionUrl={getActionUrl(item)}
          title={item?.title as string}
          description={item?.description as string}
        ></MlHorizontal>
      ))}
    </div>
  )
}
